// user

export default [
  {
    path: '/login',
    name: 'login',
    component: () =>
    import(/* webpackChunkName: "Dome" */ '@/components/user-login/index')
  }
]



// WEBPACK FOOTER //
// ./src/router/router-child/user.js